import { render } from "./ManualFullscreen.vue?vue&type=template&id=5ef484c1&scoped=true"
import script from "./ManualFullscreen.vue?vue&type=script&lang=js"
export * from "./ManualFullscreen.vue?vue&type=script&lang=js"

import "./ManualFullscreen.vue?vue&type=style&index=0&id=5ef484c1&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ef484c1"]])

export default __exports__